import { http } from '@client/monolith/legacy/services/api/http';
import type { Brand as ApiBrand } from '@monolith/legacy/types/api/brand';
import type { Product as ApiProduct } from '@monolith/legacy/types/api/product';

export async function getSneakPeek(carouselUuid: string, brandId: string) {
  return await http()
    .get(`/api/internal/v1/cms/carousel?carouselUuid=${carouselUuid}&brandId=${brandId}&include=brands`)
    .then((response) => response.data?.included ?? []);
}

export async function getBrandData(brandId: string): Promise<ApiBrand> {
  return await http()
    .get(`/api/brands/${brandId}`)
    .then((response) => response.data.data);
}

export async function getProductData(productId: string): Promise<ApiProduct> {
  return await http()
    .get(`/api/products/${productId}`)
    .then((response) => response.data.data);
}

export async function getSneakPeekData(brandId: string) {
  return await http()
    .get(`/api/internal/v1/cms/specific-carousel/product-card?carouselSelectionType=discovery-brand&brandId=${brandId}&include=brands`)
    .then((response) => response.data);
}



